import { TypographyVariants } from 'ThemeV2.0';

export const getRadioLabelTypography = (checked: boolean) => ({
  variant: (checked ? 'body2' : 'body3') as TypographyVariants,
});
